import { PulseBaseProvider } from '../../base-classes';
const _uvUri = '/data/uv/v1';
const _uvCacheKey = 'uv';

export class UvProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_uvCacheKey] = this.uvSyncer.bind(this);
    }

    async uvSyncer(params) {
        const { syncParams, resolve, reject } = params;
        const {options, pulseApi, hmac, key, id} = syncParams;
        const queryParams = JSON.parse(params.id);
        const pulseRequestUri = _uvUri;

        let apiParams = {
            ...queryParams.stdParameters,
            locationtype: 'latitudelongitude',
            location: queryParams.latitude + ',' + queryParams.longitude,
            verbose: false
        };

        try
        {
            const response = await pulseApi.getData(pulseRequestUri, apiParams, options.timeout, 'json', hmac);
            if (!response || !response.uvp) {
                reject('Invalid response');
            }

            response.responseTime = Date.now();

            global.storage.save({
                key,
                id,
                data: response
            });
            resolve(response);
        } catch(error) {
            this.logger.error(error);
            reject(error);
        }
    }

    async getUv(latitude, longitude, stdParameters) {
        let storage = global.storage;
        let pulseApi = this.pulseApi;
        let options = this.options;
        let cacheKey = _uvCacheKey;

        const syncParams = {
            latitude,
            longitude,
            verbose: false
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        try {
            const result = await storage.load({
                key: cacheKey,
                id,
                autoSync: true,
                syncInBackground: false,
                syncParams: {
                    pulseApi,
                    options,
                    hmac: true,
                    key: cacheKey,
                    id
                }
            });

            return result;
        }
        catch(error) {
            this.logger.error(error);
            throw error;
        }
    }
}

